<mat-progress-bar mode="indeterminate" *ngIf="hashTrendLoading$ | async"></mat-progress-bar>
<div class="py-1 px-2">
  <div *ngIf="(hashTrends$ | async)?.length === 0 && !(hashTrendError$ | async) && !(hashTrendLoading$ | async)">
      <img class="w-75 img-fluid  mx-auto d-block" src="../../../../assets/images/states/no-trends.svg" alt="">
      <h6 class="text-muted text-center p-3">Seems that nothing is trending at the moment!</h6>
  </div>
  <div *ngFor="let trend of (hashTrends$ | async)">
    <a routerLink="/hashtag/{{trend.hashTag}}">
      <h6>#{{trend.hashTag}}</h6>
    </a>
    <hr>
  </div>
</div>